import React from "react";

import SiloLevelDataPanel from "../../panel/silo-level-data-panel";
import NoDeviceConnectedMessage from "../../messages-panel/no-device-connected-message";
import pinLocationIcon from "../../../../assets/icons/pin-location-icon.png";
import { siloLevel } from "../../../../sensors-type";

export default function SiloLevelData({
	dataloggersList,
	sensors,
	sensorsType,
}) {
	let stationsDevices = {};

	dataloggersList.forEach((element) => {
		let getStationsNumber = element.tag.substring(6, 7);
		let stationID = "Estação " + getStationsNumber;

		// Buscar sensores conectados a este DL
		let getSensors = sensors.filter((s) => element.id === s.coletor);

		if (!stationsDevices[stationID]) {
			// Armazenar sensores por estação
			stationsDevices[stationID] = {
				sensors: [],
			};
		}

		// Tipos de Sensores [flag]
		let SL = false;

		getSensors.forEach((s) => {
			let type = sensorsType.filter((el) => s.tipo === el.id);

			if (type.length > 0) {
				s.tipo = type[0].nome;
			}

			if (s.tipo === siloLevel) SL = true;
		});

		stationsDevices[stationID].sensors.push(getSensors);
		stationsDevices[stationID].sensorsType = [{ SL: SL }];
	});

	return (
		<div className="dropdown-button-line">
			{dataloggersList.length === 0 || sensors.length === 0 ? (
				<NoDeviceConnectedMessage />
			) : null}
			<div>
				{Object.keys(stationsDevices).map((item) => {
					const devicesConnected = stationsDevices[item];
					return (
						<div key={item}>
							<div className="station-title">
								<img
									src={pinLocationIcon}
									height={"25px"}
									alt="location-pin-icon"
									style={{ marginRight: "10px" }}
								/>
								<span
									style={{
										fontWeight: "bold",
										fontSize: "16px",
									}}
								>
									{item}
								</span>
							</div>
							{devicesConnected.sensorsType.map((type) => {
								return (
									<div key={item}>
										{!type.SL ? (
											<NoDeviceConnectedMessage />
										) : (
											<div className="show-data-container">
												{type.SL ? (
													<SiloLevelDataPanel
														sensors={
															devicesConnected
																.sensors[0]
														}
													/>
												) : null}
											</div>
										)}
									</div>
								);
							})}
						</div>
					);
				})}
			</div>
		</div>
	);
}
